import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import Modal, { ModalHeader, ModalBody, ModalFooter } from './Modal';
import Button from './Button';
import Input from './Input';

/** Generic single-field create/rename modal (name in, async submit out). */
const NameModal: React.FC<{
  title: string;
  submitText: string;
  label?: string;
  initial?: string;
  placeholder?: string;
  onClose: () => void;
  onSubmit: (name: string) => Promise<void>;
}> = ({ title, submitText, label = 'Name', initial = '', placeholder, onClose, onSubmit }) => {
  const [name, setName] = useState(initial);
  const mutation = useMutation({
    mutationFn: () => onSubmit(name.trim()),
    onSuccess: onClose,
  });

  return (
    <Modal isOpen onClose={onClose} size="sm">
      <ModalHeader onClose={onClose}>{title}</ModalHeader>
      <ModalBody>
        <Input
          label={label}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={placeholder}
          autoFocus
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose} disabled={mutation.isPending}>Cancel</Button>
        <Button onClick={() => mutation.mutate()} isLoading={mutation.isPending} disabled={!name.trim()}>
          {submitText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NameModal;
